// extracted by mini-css-extract-plugin
export default {"searchProviders":"SearchProviders_searchProviders__5n2ug"};